var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-menu-separator",class:_vm.item.class})}
var staticRenderFns = []

export { render, staticRenderFns }